import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/IT-Consulting.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="IT Consulting"
				subtitle=""
				breadcrumbText="IT Consulting"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}